import React from 'react'
import Layout from '../../components/Layout'

const BrandsPage = () => {
    return (
        <React.Fragment>
            BrandsPage
        </React.Fragment>
    )
}

export default BrandsPage
